import { Button, Container } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import styles from '../style.module.scss';
import GoogleLogin from 'react-google-login';

const HeaderComponent = (props) => {
  const { handleLoginError, handleLoginSuccess } = props;

  return (
    <Container className="p-0" maxWidth="">
      <Navbar expand="lg" className={`${styles.headerStyles} justify-content-end-between`}>
        <Navbar.Brand href="#">
          <div className={styles.imageContainer}>
            <img
              alt="arzooo-header-logo"
              className={styles.headerLogo}
              src="https://static.arzoopro.com/images/falcon-logo.png"
            ></img>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="justify-content-end align-items-center flex-grow-1">
            <Nav.Link href="#whyFalcon" className={`${styles.navItem} mr-4`}>
              Why falcon?
            </Nav.Link>
            <Nav.Link href="#features" className={`${styles.navItem} mr-4`}>
              Features
            </Nav.Link>
            <img
              className={`${styles.downloadIcon} mr-4`}
              src="/images/download-now2.gif"
              onClick={() => {
                window.open('https://play.google.com/store/apps/details?id=com.arzooofalcon');
              }}
            />
            <Nav.Link href="/register" className={`${styles.navItem} mr-4`}>
              <Button
                className={`${styles.commonButtonBg}`}
                variant="contained"
                color="primary"
                moenagage-id={JSON.stringify({
                  eventName: 'User_Registration_initiation',
                  eventSource: 'Header of landing page',
                })}
              >
                Start Selling
              </Button>
            </Nav.Link>
            <Nav.Link href="/signin" className={`${styles.navItem}`}>
              <Button className={`${styles.outlinedButton}`} variant="outlined" color="primary">
                {' '}
                Sign In
              </Button>
              {/* <GoogleLogin
                clientId={
                  '868881563620-53i2nnhl1jrrrco4015u79214pjnncom.apps.googleusercontent.com'
                }
                render={(renderProps) => (
                  <Button
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                    variant="outlined"
                    color="primary"
                  >
                    {' '}
                    Sign In
                  </Button>
                )}
                buttonText="Sign In"
                onSuccess={handleLoginSuccess}
                onFailure={handleLoginError}
                cookiePolicy={'single_host_origin'}
              /> */}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
};
export default HeaderComponent;
